import React, { useState, useEffect, useRef } from "react";
import BackBar from "../home/BackBar";
import { useLocation, useNavigate } from "react-router-dom";
// import { usePlacesWidget } from "react-google-autocomplete";
import Autocomplete from "react-google-autocomplete";
import AWS from "aws-sdk";
// import InputLabel from "@mui/material/InputLabel";
import Geocode from "react-geocode";
import Select from "react-select";

// import axios from "axios";
import {
  degree_url,
  experiance_url,
  job_category_url,
  vaccancy_url,
  skills_url,
  ADMIN_JOBCATEGORY,
  ALL_CATEGORIES,
  COMPANY_LIST,
  RECURITER_PROFILE, POSTVACANCY
} from "../../Service/service";
import {
  getData,
  patchData,
  postData,
  postDataAuth,
} from "../../Service/ApiMethod";
// import CustomSelectBox from "../../common/SelectBox";
import AddDropdownPopup from "../../common/AddDropdownPopup";
import AddCompany from "./AddCompany";
// import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import Header from "../../common/HeaderAfterLogin";
import Footer from "../../common/Footer";
// import AddJobcategory from "../../common/AddJobcategory";
import { lang } from "../../lang";
import axios from "axios";

const PostForm = (props) => {


  const [isDisable, setIsdisable] = useState(false)
  const [ln, setLn] = useState('en')
  const { t } = useTranslation();
  const [prefilledDatas, setPrefilledData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  // const [prefilledData,setPrefilledData] = useState([])
  const [postVaccancy, setPostVaccancy] = useState({});
  const prefilledData = [];
  console.log(location?.state?.item, "prefilledData", prefilledData);
  const [skillOption, setSkillOption] = useState([]);
  const [address, setAddress] = useState("")
  // console.log(prefilledData?.emp_details, "emp");
  useEffect(() => {
    console.log("okkkkkkk00000000000");
    if (localStorage.getItem("language") != null) {
      setLn(localStorage.getItem("language"))
    }
    if (location?.state?.item != undefined) {
      console.log("okkkkkkkkkkkk");
      let request = {
        "vacancy_id": location?.state?.item.id
      };
      console.log("okkkkkkkkkkkk--------", request);
      // let token = localStorage.getItem("catzapp_token");
      fetch("https://api.catzapp.com/recruiter/post_vacancy_by_id/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
        },
        body: JSON.stringify(request),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data.data, "o33333333kkkkkkkkkkkkk");
          setPrefilledData(data.data)
          setPostVaccancy(data.data[0])
          let skillOptionss = []
          data.data[0]?.skill_set.map((item) => {
            let objectss = {
              value: item?.id,
              label: item?.skill_name

            }
            skillOptionss.push(objectss)
          })
          setSkillOption(skillOptionss);
          setPhone(data.data[0]?.contact_number?.replace("+", "") || "")
          setCountryCode(data.data[0]?.country_code)
          setWorkLocation(data.data[0]?.work_location)
          setLatitude(data.data[0]?.work_location_lat)
          setLongitude(data.data[0]?.work_location_long)
        })
    } else {
      const initialState = {
        id: undefined,
        title: undefined,
        job_category: undefined,
        skills: undefined,
        job_description: undefined,
        experience: undefined,
        urgent_vacancy: undefined,
        liscense_required: undefined,
        emp_details: undefined,
        no_of_vacancy: "",
        job_duration: "",
        compensation_details: undefined,
        compensation_amount: "",
        work_location: undefined,
        contact_person_name: undefined,
        contact_number: undefined,
        country_code: "€",
        highest_degree: undefined,
        degree_completion_year: undefined,
        maximum_application_allowled: "",
        from_date: undefined,
        to_date: undefined,
        search_radious: "",
        // about_company: undefined,
        company: undefined,
        currency: undefined,
        address: "",
        // category_image: undefined,
        work_location_lat: undefined,
        work_location_long: undefined,
        short_description: undefined,
      };
      setPostVaccancy(initialState)
      setSkillOption([]);
    }
  }, [])


  console.log(prefilledData?.contact_number, "number2222222",);

  var mobile_Number = prefilledData?.contact_number;
  const [categoryname, setCategoryname] = useState("")
  const [imagecatURL, setImagecatURL] = useState();
  const [jobCategories, setJobCategories] = useState();
  const [skills, setSkills] = useState();
  const [experience, setExperience] = useState();
  const [degree, setDegree] = useState();
  const [error, setError] = useState();
  const [companyName, setCompanyName] = useState();
  const [companyList, setCompanyList] = useState();
  // const [companyID, setCompanyID] = useState();
  // const [selectedDate, setSelectedDate] = useState(new Date());
  const [phone, setPhone] = useState("");

  // Dropdowns States
  const [addCat, setAddCat] = useState(false);
  const [addSkill, setAddSkill] = useState(false);
  const [addDegree, setAddDegree] = useState(false);
  const [addCompany, setAddCompany] = useState(false);
  const [addExperience, setAddExperience] = useState(false);
  // const [category, setCategory] = useState();
  const [newSkill, setNewSkill] = useState();
  const [newDegree, setNewDegree] = useState();
  const [newExperience, setNewExperience] = useState();

  // const [selectedData, setSelectedData] = useState();
  const [userData, setUserData] = useState();
  // const [imageURL, setImageURL] = useState();
  // const [multiskill, setMultiSkill] = useState([]);
  const [countryCode, setCountryCode] = useState();
  const [workLocation, setWorkLocation] = useState(
  );
  // const [skill, setskill] = useState(postVaccancy?.skills);


  const [upComp, setUpComp] = useState(false);

  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  // const[numbersString , setNumbersString] = useState(prefilledData?.skills || "")

  // const [transformRotLoc, setTransformLoc] = useState("0deg");

  // const defaultSkill = prefilledData?.skill_set?.[0]?.skill_name ?? '';


  useEffect(() => {

  }, []);

  const handleSelectChange = (selectedOption) => {
    if (selectedOption?.length === 0) {
      // Use defaultValue if selectedOption is empty
      setSkillOption("");
    } else {
      setSkillOption(selectedOption);
      console.log(selectedOption, "checkValllll", skillOption);
    }
  };

  // const skillvalue = skillOptions?.map((item)=>item?.value)

  // console.log('preskill:', skillvalue);

  const skillss = skillOption && skillOption?.map((item) => item?.value);

  console.log(skillss, "skilssssssss");

  const numbersString = skillOption?.length != 0 ? skillss?.join(", ") : "";

  console.log(numbersString, "1223322");

  // const user_company_name = props?.userData?.company_name;

  // const myRef = useRef({});

  // const handleLocationChange = (e) => {
  //   setWorkLocation(e.target.value);
  //   //  setTimeout(()=>{
  // };
  const placeid = useRef('')
  const handlePlaceSelected = (place) => {
    console.log(place, "okkkkkkk22222222222222222222222")
    placeid.current = place?.place_id
    getworkLocation(place?.formatted_address)
    setWorkLocation(place?.formatted_address);

    // setTimeout(()=>{
    //   enteredLocation()
    //  },1000)
  };
  console.log("workLocation", workLocation);

  // console.log("skillname ", prefilledData?.skill_set[0]?.skill_name);

  // const [addCat, setAddCat] = useState(false);

  const options = skills?.map((item, index) => ({
    value: item.id,
    label: item.skill_name,
  }));

  // Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");
  const lata = useRef()
  const longs = useRef()
  const getworkLocation = (val) => {
    console.log("okds")
    Geocode.fromAddress(val+ 'AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk').then(
      (response) => {
        const { lat, lng } = response?.results[0]?.geometry?.location;
        console.log(lat, lng, "lat lng ", latitude);
        lata.current = lat
        longs.current = lng
        console.log(workLocation, "work");
        setLatitude(lat);
        setLongitude(lng);
      },

      (error) => {
        console.error(error);
      }
    );
    // const apiKey = 'AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk'; // Replace with your actual API key
    // const placeId = placeid.current; // Replace with the Place ID you want to look up

    // const proxyUrl = 'https://cors-anywhere.herokuapp.com/';

    // const apiUrl = `${proxyUrl}https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=${apiKey}`;


    // axios.get(apiUrl)
    // .then(response => {
    //   const data = response.data;
    //   if (data.status === 'OK') {
    //     const location = data.result.geometry.location;
    //     const latitude = location.lat;
    //     const longitude = location.lng;
  
    //     console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
    //   } else {
    //     console.error(`Error: ${data.status}`);
    //   }
    // })
    // .catch(error => console.error('Error fetching data:', error));
  }


  useEffect(() => {

    Geocode.fromAddress(workLocation).then(
      (response) => {
        const { lat, lng } = response?.results[0]?.geometry?.location;
        console.log(lat, lng, "lat lng ", latitude);
        lata.current = lat
        longs.current = lng
        console.log(workLocation, "work");
        setLatitude(lat);
        setLongitude(lng);
      },

      (error) => {
        console.error(error);
      }
    );
  }, [workLocation]);

  console.log(latitude, longitude, "loccc");
  const userLa = useRef()
  const MyprofileData = () => {
    getData(RECURITER_PROFILE)
      .then((response) => response.json())
      .then((data) => {
        setUserData(data?.data);
        userLa.current = data?.data
        console.log(mobile_Number, phone, "dataRec", data?.data);
      });
  };

  const Profile_Status = userData?.recruiter_profile;
  // console.log()





  const objItem = {
    id: postVaccancy?.id == undefined ? 0 : Number(postVaccancy?.id),
    title: postVaccancy?.title,
    job_category: postVaccancy.job_category,
    skills: numbersString,
    job_description: postVaccancy.job_description,
    experience: Number(postVaccancy.experience),
    urgent_vacancy: `${postVaccancy?.urgent_vacancy}`,
    liscense_required: `${postVaccancy.liscense_required}`,
    emp_details: postVaccancy.emp_details,
    no_of_vacancy: postVaccancy.no_of_vacancy,
    job_duration: postVaccancy.job_duration,
    compensation_details: postVaccancy.compensation_details,
    compensation_amount: postVaccancy.compensation_amount,
    work_location: `${workLocation}`,
    contact_person_name: `${userData?.first_name} ${userData?.last_name}`,
    contact_number: `+${phone}`,
    country_code: countryCode,
    highest_degree: `${postVaccancy.highest_degree}`,
    degree_completion_year: postVaccancy.degree_completion_year,
    maximum_application_allowled: postVaccancy.maximum_application_allowled,
    from_date: postVaccancy.from_date,
    to_date: postVaccancy.to_date,
    search_radious: postVaccancy.search_radious,
    // about_company: postVaccancy?.about_company,
    company: `${userData?.company}`,
    currency: postVaccancy?.currency == undefined ? "€" : postVaccancy?.currency,
    // category_image: postVaccancy?.category_image || `${imageURL}`,
    address: postVaccancy.address,
    work_location_lat: latitude,
    work_location_long: longitude,
    short_description: postVaccancy?.short_description,
  };

  console.log("state Object ", postVaccancy);
  console.log("userData ", userData);
  console.log("objitem ", objItem);

  const navigateToSuccess = () => {
    navigate("/post-success");
  };

  // const myRef = React.createRef();

  const executeScroll = () => {
    console.log("hello");
    // document.getElementById("HEADER").scrollIntoView(-100, -20);
    // myRef.current.scrollTo(200, 0)
    // window.scrollTo(200, 0);
  };

  // const startPage =()=>{
  //     document.getElementById('HEADER').scrollIntoView(-100,-10);
  //     document.getElementById('HEADERR').scrollIntoView(150,0);
  //     };
  const [stopbtn, setStopbtn] = useState(false)
  const objItems = {
    id: 0,
    title: postVaccancy?.title,
    job_category: postVaccancy.job_category,
    skills: numbersString,
    job_description: postVaccancy.job_description,
    experience: Number(postVaccancy.experience),
    urgent_vacancy: `${postVaccancy?.urgent_vacancy}`,
    liscense_required: `${postVaccancy.liscense_required}`,
    emp_details: postVaccancy.emp_details,
    no_of_vacancy: postVaccancy.no_of_vacancy,
    job_duration: postVaccancy.job_duration,
    compensation_details: postVaccancy.compensation_details,
    compensation_amount: postVaccancy.compensation_amount,
    work_location: `${workLocation}`,
    contact_person_name: `${userData?.first_name} ${userData?.last_name}`,
    contact_number: `${phone == "" ? userData?.user?.phone : phone}`,
    country_code: phone == "" ? userData?.user?.phone.slice(0, userData?.user?.phone.length - 10) : countryCode,
    highest_degree: `${postVaccancy.highest_degree}`,
    degree_completion_year: postVaccancy.degree_completion_year,
    maximum_application_allowled: postVaccancy.maximum_application_allowled,
    from_date: postVaccancy.from_date,
    to_date: postVaccancy.to_date,
    search_radious: postVaccancy.search_radious,
    // about_company: userData?.about_company,
    company: `${userData?.company}`,
    currency: "€",
    // category_image: postVaccancy?.category_image || `${imageURL}`,
    address: postVaccancy.address,
    work_location_lat: latitude == undefined ? lata.current == undefined ? userLa.current?.latitude:lata.current : latitude,
    work_location_long: longitude == undefined ? longs.current == undefined ? userLa.current?.longitude:longs.current : longitude,
    short_description: postVaccancy?.short_description,
  };

  console.log("objectitems", objItems);
  const handlePostVaccancy = async (e) => {
    setStopbtn(true)
    e.preventDefault();
    if (Profile_Status != "100") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.Home["Your profile is incomplete! Please complete your profile to find the right candidate for your job"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)

      navigate("/MainProfile");
    } else if (objItems.title === "" || objItems.title == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Enter Job Title"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (postVaccancy.job_category == null || postVaccancy.job_category == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Select Job Category"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems?.skills === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Select Required Skills"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems?.experience == NaN) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Select Required Experience"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.job_description === "" || objItems.job_description == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Job Description"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.work_location === "" || objItems.work_location == "undefined") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Work Location"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.contact_person_name === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Contact Person Name"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.contact_number === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Contact Number"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.country_code === "") {
      alert("Please Enter country_code");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.compensation_details === "" || objItems.compensation_details == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please enter Compensation Details"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.compensation_amount === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please enter Compensation Amount"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.emp_details === "" || objItems.emp_details == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please select employment details"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.no_of_vacancy === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["No Of Vacancies"] : "")
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.job_duration === "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please enter Job Duration"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.urgent_vacancy === "" || objItems.urgent_vacancy == "undefined") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please select urgent vacancy"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    else if (objItems.search_radious == "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please enter search radius"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    else if (objItems.highest_degree === "" || objItems.highest_degree == "undefined") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please select Highest Degree"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.short_description === "" || objItems.short_description === undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please enter short description"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    } else if (objItems.degree_completion_year === undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LastL["Please select Highest Degree completion year"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    else if (objItems.from_date == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.new["From Date"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    else if (objItems.to_date == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory["End Date"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    // else if(objItems.work_location_lat == undefined){
    //   alert("Please Select Location again");
    //     setTimeout(()=>{
    //     setStopbtn(false)
    //   },1000)
    //   console.log(objItems,"ddd")
    // }
    else if (objItems.liscense_required == "undefined") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please select liscense required"] : "");
      setTimeout(() => {
        setStopbtn(false)
      }, 1000)
    }
    // else if(objItem.category_image === ""){
    //   alert("Please Enter Image");

    // }
    else {
      if (userData.is_subscribed == true) {
        await postData(objItems, POSTVACANCY)
          .then((response) => response.json())
          .then((data) => {
            console.log(data, "vaccancy_url", objItems);
            setTimeout(() => {
              setStopbtn(false)
            }, 1000)
            if (data.message !== "") {
              console.log("from API ", data.error_message);
              setTimeout(() => {
                setStopbtn(false)
              }, 1000)
              // alert(data?.message);
            } else {
              console.log("'data.message' is not empthy");
              setTimeout(() => {
                setStopbtn(false)
              }, 1000)
            }
            try {
              if (data.error_message) {
                alert("Plese Fill All Fields");
                setTimeout(() => {
                  setStopbtn(false)
                }, 1000)
              } else if (data.message) {
                alert(data.message);
                navigateToSuccess();
                setTimeout(() => {
                  setStopbtn(false)
                }, 1000)
              }
            } catch (err) {
              console.log("error hgappended", err);
              setTimeout(() => {
                setStopbtn(false)
              }, 1000)
              setError(err.message, "email already exists");
              alert("Error", error);
            }
          });
      } else {
        alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.Lastest["UpGradePlan"] : "")
        setTimeout(() => {
          setStopbtn(false)
        }, 1000)
      }
    }
  };


  const handleUpdate = async (e) => {
    console.log(objItem, "checkObject");
    e.preventDefault();
    if (Profile_Status != "100") {
      alert("Please Complete your profile First");
      navigate("/MainProfile");
    } else if (objItem.title === "") {
      alert("Title Required");
    } else if (postVaccancy.job_category === null) {
      alert("Enter Job Category");
    } else if (objItem.skills === "") {
      alert("select skills");
    } else if (postVaccancy.experience === null) {
      alert("Enter experiance");
    } else if (objItem.job_description === "") {
      alert("enter Job Description ");
    } else if (objItem.work_location === "") {
      alert("Please Enter Work Location");
    } else if (objItem.contact_person_name === "") {
      alert("enter contact_person_name ");
    } else if (objItem.contact_number === "") {
      alert("Please Enter contact_number");
    } else if (objItem.compensation_details === "") {
      alert("enter compensation_details ");
    } else if (objItem.compensation_amount === "") {
      alert("Please compensation_amount");
    } else if (objItem.emp_details === "") {
      alert("enter emp_details ");
    } else if (objItem.no_of_vacancy === "") {
      alert("Please Enter no_of_vacancy");
    } else if (objItem.job_duration === "") {
      alert("enter job_duration ");
    } else if (objItem.urgent_vacancy === "") {
      alert("Please Enter Work Location");
    } else if (objItem.highest_degree === null) {
      alert("Please Enter Highest Degree");
    } else if (objItem.search_radious == "") {
      alert("Please Enter Search Radious");
    }
    else {
      await patchData(objItem, POSTVACANCY)
        .then((response) => response.json())
        .then((data) => {
          console.log(data, "vaccancy_url");

          if (data.message !== "") {
            console.log("from API ", data.error_message);
            // alert(data?.message);
          } else {
            console.log("'data.message' is not empthy");
          }
          try {
            if (data.error_message) {
              alert("Plese Fill All Fields");
            } else if (data.message) {
              alert(data.message);
              navigate("/vaccancy");
            }
          } catch (err) {
            console.log("error hgappended", err);
            setError(err.message, "email already exists");
            alert("Error", error);
          }
        });
      // patchData(objItem, vaccancy_url)
      //   .then(res => res.json())
      //   .then(data => console.log("data", data))
      //   .catch((error) => {
      //     console.log(error.message)
      //   })
    }
  };

  const GOOGLE_PLACES_API_KEY = "AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk";

  // const postCategory = async () => {
  //   if (category) {
  //     const catObj = {
  //       category_name: category,

  //       // category_image: "https://atwpl.com/catz/icon-painter.svg",
  //     };
  //     await postData(catObj, job_category_url)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data?.error_message) {
  //           alert(data?.error_message);
  //           // alert(data?.message);
  //         } else {
  //           setAddCat(false);
  //           alert(data?.message);
  //           getJobCategories();
  //         }
  //         try {
  //           console.log("category", data);
  //         } catch (err) {
  //           console.log("error hgappended", err);
  //           setError(err.message, "email already exists");
  //           // alert("Eoorrror", err);
  //         }
  //       });
  //   } else {
  //     alert("You didn't add any new job category.");
  //   }
  // };

  const postSkill = async () => {
    if (newSkill) {
      const catObj = {
        skill_name: newSkill,
      };
      await postData(catObj, skills_url)
        .then((response) => response.json())
        .then((data) => {
          if (data?.error_message) {
            alert(data?.error_message);
          } else {
            setAddSkill(false);
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["New skill addded"] : "");
            setNewSkill("")
            getSkills();
          }

          try {
            console.log(data?.error_message, "category122");
          } catch (err) {
            setError(data?.error_message);
            alert(error);
          }
        });
    } else {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["You didn't add any new skill."] : "");
    }
  };

  const postDegree = async () => {
    if (newDegree) {
      const catObj = {
        degree: newDegree,
      };
      await postData(catObj, degree_url)
        .then((response) => response.json())
        .then((data) => {
          console.log("ssssss", data)
          if (data.message !== "") {
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Degree add successfully"] : "");
            setAddDegree(false);

            getDegree();
          } else {
            alert(data?.error_message);
          }
          try {
            console.log(data);
          } catch (err) {
            console.log("error happended", err);
            setError(err.message, "email already exists");
            alert("Eoorrror", err);
          }
        });
    } else {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["You didn't add any new Degree"] : "");
    }
  };
  const postExperience = async () => {
    if (newExperience) {
      const catObj = {
        experience: newExperience,
      };
      await postData(catObj, experiance_url)
        .then((response) => response.json())
        .then((data) => {
          if (data?.message !== "") {
            alert("SuccesFully posted");
            setAddExperience(false);
            getExperience();
          } else {
            alert(data?.error_message);
          }
          try {
            console.log(data);
          } catch (err) {
            console.log("error hgappended", err);
            setError(err.message, "email already exists");
            // alert("Eoorrror", err);
          }
        });
    } else {
      alert("You didn't add any new experinece, please select from given one.");
    }
  };

  // const postCompany = async () => {
  //   const catObj = {
  //     company_name: newCompany,
  //     company_image: companyImage,
  //     company_location: companyLocation,
  //     about_company: aboutCompany,
  //     company_website: companyWebsite,
  //   };

  //   if (!newCompany) {
  //     alert("Company name Required");
  //   } else if (!companyLocation) {
  //     alert("Enter company location");
  //   } else if (!aboutCompany) {
  //     alert("enter few words about company ");
  //   } else {
  //     await postData(catObj, COMPANY_LIST)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data?.error_message) {
  //           alert(data?.error_message);
  //         }else{
  //           setAddCompany(false);
  //           alert("Company Added")

  //         }
  //         try {
  //           console.log(data);
  //         } catch (err) {
  //           console.log("error hgappended", err);
  //           setError(err.message, "email already exists");
  //           // alert("Eoorrror", err);
  //         }
  //       });
  //   }
  // };

  // const onSearch = () => {

  //   let temp = [...];
  //   if (searchKey) {
  //     const newData = temp?.filter((item) => (item?.?.toLowerCase()?.includes(searchKey?.toLowerCase())))
  //     console.log('newData', newData)
  //     setSearchData(newData)

  //   }
  //   else {
  //   alert("Please Enter a value")

  //   }

  // }
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setSelectedData({
  //     ...selectedData,
  //     [name]: value,
  //   });
  // };

  // const initialValues = {
  //   id: "",
  //   title: "",
  //   job_category: null,
  //   skills: null,
  //   job_description: "",
  //   short_description: "",
  //   experience: Number,
  //   urgent_vacancy: null,
  //   liscense_required: null,
  //   emp_details: "",
  //   no_of_vacancy: "",
  //   job_duration: "",
  //   compensation_details: "",
  //   compensation_amount: "",
  //   work_location: "",
  //   contact_person_name: "",
  //   contact_number: "",
  //   highest_degree: null,
  //   degree_completion_year: "",
  //   maximum_application_allowled: "",
  //   from_date: "",
  //   to_date: "",
  //   search_radious: "",
  //   company: "",
  //   about_company: "",
  //   currency: "",
  //   category_image: "./images/Docter.png",
  //   work_location_lat: latitude,
  //   work_location_long: longitude
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setSelectedData({
  //     ...selectedData,
  //     [name]: value,
  //   });
  // };

  useEffect(() => {
    getCompany();
  }, [upComp]);
  console.log(upComp, "state");

  //  function handleUpdate() {
  //    fetch(`https://dev.jobportalapi.atwpl.com/recruiter/post_vacancy/`, {
  //     method: "PATCH",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
  //     },
  //     body: JSON.stringify(postVaccancy),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data)
  //       // useNavigate
  //     });

  //   prefilledData.fetchData();
  // }

  // const patchVaccancy = () => {
  //   patchData(setObj , vaccancy_url)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setJobCategories(data.data);
  //     })
  //     .catch((error) => {
  //       console.log("Error in categories from Post Form", error);
  //     });
  // };

  // const message = (mes) => {
  //   Swal.fire(mes);
  // };
  // const handupdate = () => {
  //   patchData();
  //   props.closePopup();
  //   if (prefilledData === "") {
  //     message("Please Fill Valid PostForm");
  //     return;
  //   }
  //   message("Updated Successfully");
  // };

  // console.log(prefilledData.id);

  const getJobCategories = () => {
    let changeC = "recruiter/JobCategories/"
    getData(changeC)
      .then((response) => response.json())
      .then((data) => {
        console.log("jobcateg", data);
        setJobCategories(data?.data);
      })
      .catch((error) => {
        console.log("Error in categories from Post Form", error);
      });
  };
  console.log("job category", jobCategories);

  const getCompany = () => {
    getData(COMPANY_LIST)
      .then((response) => response.json())
      .then((data) => {
        setCompanyName(data?.data);
      })
      .catch((error) => {
        console.log("Error in categories from Post Form", error);
      });
  };
  // console.log("comp", companyName)

  const getSkills = () => {
    getData(skills_url)
      .then((response) => response.json())
      .then((data) => {
        setSkills(data?.data);
      })
      .catch((error) => {
        console.log("Error in getSkills from Post Form", error);
      });
  };

  const getExperience = () => {
    getData(experiance_url)
      .then((response) => response.json())
      .then((data) => {
        setExperience(data.data);
      })
      .catch((error) => {
        console.log("Error in getExperience from Post Form", error);
      });
  };
  const getDegree = () => {
    getData(degree_url)
      .then((response) => response.json())
      .then((data) => {
        setDegree(data.data);
      })
      .catch((error) => {
        console.log("Error in getDegree from Post Form", error);
      });
  };
  useEffect(() => {
    getJobCategories();
    getSkills();
    getExperience();
    getDegree();
    getCompany();
    MyprofileData();
    // setTimeout(() => {
    executeScroll();
    // }, 2000)
  }, []);

  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(function (position) {
  //     console.log("Latitude is :", position.coords.latitude);
  //     console.log("Longitude is :", position.coords.longitude);
  //     setLatitude(position?.coords?.latitude);
  //     setLongitude(position?.coords?.longitude);
  //   });
  // }, []);

  // console.log(latitude, longitude);

  // const handleRecruiterImage = (e) => {
  //   let s3 = new AWS.S3({
  //     accessKeyId: "AKIA2GWTBVL6WX6U75ZC",
  //     secretAccessKey: "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",
  //     region: "eu-central-1",
  //   });

  //   const params = {
  //     Bucket: "catzapp-dev",
  //     Key: e.target.files[0]?.name,
  //     Body: e.target.files[0],
  //     ContentType: e.target.files[0]?.type || "image/png",
  //     ACL: "public-read",
  //   };

  //   s3.upload(params, (err, data) => {
  //     if (err) {
  //       console.log(err);
  //     } else {
  //       console.log(`File uploaded successfully. ${data?.Location}`);
  //       setImageURL(data?.Location);
  //     }
  //   });
  // };

  // console.log("imageURL", imageURL);

  const getSelectedCandidate = () => {
    getData(COMPANY_LIST)
      .then((response) => response.json())
      .then((data) => {
        setCompanyList(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };

  // const handleSelectedCompany = (id) => {
  //   setCompanyID(id);
  // };

  useEffect(() => {
    getSelectedCandidate();
  }, []);

  useEffect(() => {
    getSelectedCandidate();
  }, [upComp]);

  // console.log("multiskill", multiskill)
  // console.log("countryCode", countryCode)

  // const handleDateChange = (event) => {
  //   setSelectedDate(new Date(event.target.value));
  // };

  const today = new Date();
  const minDate = today.toISOString().slice(0, 10);





  const handleRecruiterImagescat = (e) => {
    let s3 = new AWS.S3({
      accessKeyId: "AKIA2GWTBVL6WX6U75ZC",
      secretAccessKey: "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",
      region: "eu-central-1",
    });

    const params = {
      Bucket: "catzapp-dev",
      Key: e.target.files[0]?.name,
      Body: e.target.files[0],
      ContentType: e.target.files[0]?.type || "image/png",
      ACL: "public-read",
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        console.log(`File uploaded successfully. ${data?.Location}`);
        setImagecatURL(data?.Location);
        setTimeout(() => {
          setIsdisable(false)
        }, 1500)
      }
    });
  };





  async function postHandlecat() {
    let dataaaa = { "category_name": categoryname, "category_icon": imagecatURL }
    console.log(dataaaa, "sssssdddddddd")
    if (dataaaa.category_name != "" && dataaaa.category_icon != undefined) {
      await postData(dataaaa, job_category_url)
        .then((response) => response.json())
        .then((data) => {
          if (data?.error_message) {
            alert(data?.error_message);
            // alert(data?.message);
          } else {
            setAddCat(false);
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Category add successfully"] : "");
            setCategoryname("")
            getJobCategories();
          }
        });
    } else if (dataaaa.category_name == "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Please Enter Category Name"] : "")
    } else if (dataaaa.category_icon == undefined) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Upload Category Image"] : "")
    }

    // await fetch('https://api.catzapp.com/adminportal/JobCategories/', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer  ${localStorage.getItem('token')}`,
    //   },
    //   body: JSON.stringify({ "category_name": categoryname,"category_icon": imageURL }),
    // })
    //   .then((response) => response.json())
    //   .then((data) => console.log(data))

    // props.fetchData();
  }






  return (
    <>
      <Header />
      <div id="HEADER" className="wrapped-content-area my-0">
        <BackBar title={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Post Vacancy"] : ""} />
        <div className="container">
          <form
            action=""
            className="form-container my-3 "
            style={{ paddingTop: "20px" }}
          >
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <h5 className="mb-3 form-heading">{t("Job Details")}</h5>
                <div style={{ display: 'flex' }}>
                  <input
                    required
                    type="text"
                    placeholder={t("Enter Job Title")}
                    className="input-text w-100 mb-2"
                    onChange={(e) => {
                      let obj = { ...postVaccancy };
                      // if(prefilledData?.title){
                      // obj["title"] =prefilledData?.title;
                      //   }else{
                      // obj["title"] =e.target.value;
                      //   }
                      obj["title"] = e.target.value;
                      setPostVaccancy(obj);
                      // setPostVaccancy(prev => ({
                      //   ...prev.postVaccancy,
                      //   // ...prev,
                      //   title: e.target.value
                      // })
                      // )
                    }}
                    defaultValue={
                      prefilledData?.title
                        ? prefilledData?.title
                        : postVaccancy.title
                    }
                  /><span style={{ color: "red" }}>*</span></div>
                {/* <div className=" relative mb-2">
                <input
                  id="company_name"
                  className="input-text w-100"
                  style={{ color: "black" }}

                  value={(userData?.company_name)}

                  // disabled="disabled"
                >

                </input>

              </div> */}
                {/* <div className="mb-2 relative">
                  <select
                    name="Select Vacancy"
                    onChange={(e) => handleSelectedCompany(e.target.value)}
                    style={{
                      width: "100%",
                      // marginBottom: "10px",
                      height: "48px",
                      borderRadius: "6px",
                      border: "1px solid #dfe2e2",
                    }}
                  >
                    <option value={user_company_name} default>
                      {userData?.company_name || ""}
                    </option>
                    {companyList?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.company_name}
                      </option>
                    ))}
                  </select>

                  <button
                    className=" btn btn-primary addFields "
                    style={{ height: "48px" }}
                    onClick={(e) => {
                      // setAddCat(true);
                      setAddCompany(true);
                      e.preventDefault();
                    }}
                  >
                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
                  </button>
                </div> */}
                <div style={{ display: 'flex', width: '100%' }}>
                  <div className="relative mb-2" style={{ width: '100%' }}>
                    <select
                      id="jobCategory"
                      className="input-text w-100"
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Select Job Category"] : ""}
                      value={postVaccancy?.job_category}
                      onChange={(e) => {
                        let obj = { ...postVaccancy };
                        obj["job_category"] = e.target.value;
                        setPostVaccancy(obj);
                      }}
                      defaultValue={
                        prefilledData?.job_category_name
                          ? prefilledData?.job_category_name
                          : postVaccancy?.job_category
                      }
                    >
                      <option value="0">{lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Select Job Category"] : ""}</option>
                      {jobCategories?.map((item, index) => {
                        return (
                          <option value={item.id} id={item?.id} key={index}>
                            {item?.category_name}
                          </option>
                        );
                      })}
                    </select>

                    <button
                      className=" btn btn-primary addFields h-100"
                      onClick={(e) => {
                        e.preventDefault();
                        setAddCat(true);
                      }}
                    >
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
                    </button>
                  </div>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div style={{ display: 'flex', width: '100%' }}>
                  <div className="relative mb-2" style={{ width: '100%' }}>
                    <div>
                      <Select
                        options={options}
                        isMulti
                        value={skillOption}
                        defaultValue={skillOption}
                        placeholder={t("Select Required skills")}
                        onChange={handleSelectChange}
                      />
                      <button
                        style={{ position: "absolute", top: "0px" }}
                        className=" btn btn-primary addFields h-100"
                        onClick={(e) => {
                          e.preventDefault();
                          setAddSkill(true);
                        }}
                      >
                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
                      </button>
                    </div>
                  </div>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div style={{ display: 'flex', width: '100%' }}>
                  <input
                    type="text"
                    id="Short_description"
                    maxLength={200}
                    className="input-text w-100 mb-2"
                    placeholder={t("Enter Short Description")}
                    onChange={(e) => {
                      let obj = { ...postVaccancy };
                      obj["short_description"] = e.target.value;
                      setPostVaccancy(obj);
                    }}
                    // value={postVaccancy.short_description}
                    defaultValue={
                      prefilledData?.short_description
                        ? prefilledData?.short_description
                        : postVaccancy?.short_description
                    }
                  />
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div style={{ display: 'flex', width: '100%' }}>
                  <textarea
                    name=""
                    id="jobDescription"
                    cols=""
                    className="input-text w-100 mb-2"
                    rows="4"
                    maxLength={600}
                    placeholder={t("Job Description")}
                    onChange={(e) => {
                      let obj = { ...postVaccancy };
                      obj["job_description"] = e.target.value;
                      setPostVaccancy(obj);
                    }}
                    // value={postVaccancy.job_description}
                    defaultValue={
                      prefilledData?.job_description
                        ? prefilledData?.job_description
                        : postVaccancy?.job_description
                    }
                  ></textarea>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div style={{ display: 'flex', width: '100%' }}>
                  <div className="relative mb-2" style={{ width: '100%' }}>
                    <select
                      id="experience"
                      className="input-text w-100"
                      // value={item?.experience}
                      placeholder={t("Select Required Experience")}
                      value={postVaccancy?.experience}
                      onChange={(e) => {
                        let obj = { ...postVaccancy };
                        obj["experience"] = e.target.value;
                        setPostVaccancy(obj);
                      }}
                      // value={postVaccancy.experience}
                      defaultValue={
                        prefilledData?.experience_name
                          ? prefilledData?.experience_name
                          : postVaccancy?.experience
                      }
                    >
                      <option value="select">
                        {t("Select Required Experience")}
                      </option>
                      {experience?.map((item, index) => {
                        return (
                          <option value={item?.id} id={item?.id} key={index}>
                            {item.experience}
                          </option>
                        );
                      })}
                    </select>
                    {/* <button
                    className=" btn btn-primary addFields h-100"
                    onClick={(e) => {
                      e.preventDefault();
                      setAddExperience(true);
                    }}
                  >
                    Add
                  </button> */}
                  </div>
                  <span style={{ color: "red" }}>*</span>
                </div>
                {/* <textarea
                  name=""
                  id="jobDescription"
                  cols=""
                  className="input-text w-100 mb-2"
                  rows="4"
                  placeholder="Job Description"
                  onChange={(e) => {
                    let obj = { ...postVaccancy };
                    obj["job_description"] = e.target.value;
                    setPostVaccancy(obj);
                  }}
                  // value={postVaccancy.job_description}
                  defaultValue={(prefilledData?.job_description) ? (prefilledData?.job_description) : (postVaccancy?.job_description)}
                ></textarea> */}

                {/* <input
                  type="text"
                  id="short_description"
                  className="input-text w-100 mb-2"
                  placeholder="Short Description"
                  onChange={(e) => {
                    let obj = { ...postVaccancy };
                    obj["short_description"] = e.target.value;
                    setPostVaccancy(obj);
                  }}
                  // value={postVaccancy.short_description}
                  defaultValue={(prefilledData?.short_description) ? (prefilledData?.short_description) : (postVaccancy?.short_description)}
                /> */}
                <p className="text mt-2 mb-3">{t("Is this vacancy Urgent")} ? <span style={{ color: "red" }}>*</span></p>
                <div className="d-flex w-100 ">
                  <span className="w-25">
                    <input
                      type="radio"
                      name="urgent-vaccancy"
                      id="urgent-vaccancy-answer-1"
                      className="mr-2"
                      checked={postVaccancy?.urgent_vacancy === true}
                      onChange={(e) => {
                        let obj = { ...postVaccancy, urgent_vacancy: true };
                        // obj["urgent_vacancy"] = e.target.checked;
                        setPostVaccancy(obj);
                      }}
                      value={true}
                    />
                    <span className="text">{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Yes"] : ""}</span>
                  </span>
                  <span className="w-25">
                    <input
                      type="radio"
                      name="urgent-vaccancy"
                      id="urgent-vaccancy-answer-2"
                      checked={postVaccancy?.urgent_vacancy === false}
                      className="mr-2"
                      onChange={(e) => {
                        let obj = { ...postVaccancy, urgent_vacancy: false };
                        // obj["urgent_vacancy"] = e.target.checked;
                        setPostVaccancy(obj);
                      }}
                      value={false}
                    />
                    <span className="text">{t("No")}</span>
                  </span>
                </div>

                <p className="text mt-2 mb-3">{t("Is Liscense Required")} ?<span style={{ color: "red" }}>*</span></p>
                <div className="d-flex w-100">
                  <span className="w-25">
                    <input
                      type="radio"
                      name="liscense"
                      id="liscense-1"
                      className="mr-2"
                      checked={postVaccancy?.liscense_required === true}
                      onChange={(e) => {
                        let obj = { ...postVaccancy, liscense_required: true };
                        // obj["liscense_required"] = e.target.value;
                        setPostVaccancy(obj);
                      }}
                      value={false}
                    />
                    <span className="text">{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Yes"] : ""}</span>
                  </span>
                  <span className="w-25">
                    <input
                      type="radio"
                      name="liscense"
                      id="liscense-2"
                      className="mr-2"
                      checked={postVaccancy?.liscense_required === false}
                      onChange={(e) => {
                        let obj = { ...postVaccancy, liscense_required: false };
                        // obj["liscense_required"] = e.target.value;
                        // !postVaccancy?.liscense_required;
                        setPostVaccancy(obj);
                      }}
                      value={false}
                    />
                    <span className="text">{t("No")}</span>
                  </span>
                </div>

                <h5 className="my-3 form-heading">{t("Employment Details")}<span style={{ color: "red" }}>*</span></h5>
                <div className="Employment-Details mt-3">
                  <div className="Employment-Details-inner  horizontal-center d-flex my-2  w-75">
                    <div className="">
                      <input
                        type="radio"
                        className="mr-2"
                        name="Employment"
                        value="Part Time"
                        checked={postVaccancy?.emp_details === "Part Time"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["emp_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        id="1"
                      />
                      <span className="text">{t("Part Time")}</span>
                    </div>

                    <div className="">
                      <input
                        type="radio"
                        className="mr-2"
                        name="Employment"
                        value="Full Time"
                        checked={postVaccancy?.emp_details === "Full Time"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["emp_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        id="full"
                      />
                      <span className="text">{t("Full Time")}</span>
                    </div>

                    <div className="horizontal-center">
                      <input
                        type="radio"
                        className="mr-2"
                        value="Contract"
                        name="Employment"
                        id="3"
                        checked={postVaccancy?.emp_details === "Contract"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["emp_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                      />
                      <span className="text">{t("Contract")}</span>
                    </div>
                  </div>

                  <input
                    type="text"
                    placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["No Of Vacancies"] : ""}
                    maxLength={3}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^[0-9]*$/.test(inputValue)) {
                        let obj = { ...postVaccancy };
                        obj["no_of_vacancy"] = inputValue;
                        setPostVaccancy(obj);
                      }
                    }}
                    value={postVaccancy.no_of_vacancy == undefined ? prefilledData?.no_of_vacancy : postVaccancy?.no_of_vacancy}
                  // defaultValue={
                  //   prefilledData?.no_of_vacancy
                  //     ? prefilledData?.no_of_vacancy
                  //     : postVaccancy?.no_of_vacancy
                  // }
                  />

                  <input
                    type="text"
                    placeholder={t("Job Duration(in days)")}
                    maxLength={4}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      var inputValue = e.target.value;
                      if (/^[0-9]*$/.test(e.target.value)) {
                        let obj = { ...postVaccancy };
                        obj["job_duration"] = inputValue;
                        setPostVaccancy(obj);
                      }
                    }}
                    value={postVaccancy.job_duration == undefined ? prefilledData?.job_duration : postVaccancy?.job_duration}
                  // defaultValue={
                  //   prefilledData?.job_duration
                  //     ? prefilledData?.job_duration
                  //     : postVaccancy?.job_duration
                  // }
                  />
                </div>
                <h5 className="my-3 form-heading" style={{marginBottom:0}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Compensation Details"]:""}<span style={{ color: "red" }}>*</span></h5>
                <h5 className="my-3 form-heading">{"("+lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Select payment period above and enter salary in the field below"]:""+")"}<span style={{ color: "red" }}>*</span></h5>
                <div className="Employment-Details">
                  <div className="Employment-Details-inner horizontal-center d-flex w-75">
                    <div className="">
                      <input
                        type="radio"
                        className="mr-1"
                        name="Compensation"
                        id="daily"
                        checked={postVaccancy?.compensation_details === "Daily"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["compensation_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        value="Daily"
                      />
                      <span className="text">{t("Daily")}</span>
                    </div>

                    <div className="">
                      <input
                        type="radio"
                        className="mr-1"
                        name="Compensation"
                        checked={postVaccancy?.compensation_details === "Weekly"}
                        id="weekly"
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["compensation_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        value="Weekly"
                      />
                      <span className="text">{t("Weekly")}</span>
                    </div>

                    <div className="horizontal-center">
                      <input
                        type="radio"
                        className="mr-1"
                        name="Compensation"
                        id="monthly"
                        checked={postVaccancy?.compensation_details === "Monthly"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["compensation_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        value="Monthly"
                      />
                      <span className="text">{t("Monthly")}</span>
                    </div>

                    <div className="horizontal-center mb-1">
                      <input
                        type="radio"
                        className="mr-1"
                        name="Compensation"
                        id="yearly"
                        checked={postVaccancy?.compensation_details === "Yearly"}
                        onChange={(e) => {
                          let obj = { ...postVaccancy };
                          obj["compensation_details"] = e.target.value;
                          setPostVaccancy(obj);
                        }}
                        value="Yearly"
                      />
                      <span className="text">{t("Yearly")}</span>
                    </div>
                  </div>

                  <input
                    type="text"
                    placeholder={t("Compensation Amount")}
                    maxLength={6}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      var inputValue = e.target.value;
                      if (/^[0-9]*$/.test(e.target.value)) {
                        let obj = { ...postVaccancy };
                        obj["compensation_amount"] = inputValue;
                        setPostVaccancy(obj);
                      }
                    }}
                    value={prefilledData?.compensation_amount ? prefilledData?.compensation_amount : postVaccancy?.compensation_amount}
                  // defaultValue={
                  //   prefilledData?.compensation_amount
                  //     ? prefilledData?.compensation_amount
                  //     : postVaccancy?.compensation_amount
                  // }
                  />
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12">
                <h5 className="mb-3 form-heading">{t("Company Details")}<span style={{ color: "red" }}>*</span></h5>
                <div className="Employment-Details" style={{ marginBottom: 10 }}>
                  <div className=" relative">
                    <input
                      type="text"
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Enter Address"] : ""}
                      style={{ marginTop: 0 }}
                      className="input-text w-100"
                      onChange={(e) => {
                        var inputValue = e.target.value;
                        let obj = { ...postVaccancy };
                        obj["address"] = inputValue;
                        setPostVaccancy(obj);
                      }}
                      value={prefilledData?.address ? prefilledData?.address : postVaccancy?.address}
                    // defaultValue={
                    //   prefilledData?.compensation_amount
                    //     ? prefilledData?.compensation_amount
                    //     : postVaccancy?.compensation_amount
                    // }
                    />
                  </div>
                </div>


                <div className="Employment-Details">
                  <div className=" relative">
                    <Autocomplete
                      className="input-text w-100"
                      placeholder={t("Work Location")}
                      defaultValue={
                        prefilledData?.work_location
                          ? prefilledData?.work_location
                          : postVaccancy?.work_location
                      }
                      onChange={(e) => {
                        // setWorkLocation(e.target.value);
                      }}
                      // value={prefilledData?.work_location}
                      apiKey={GOOGLE_PLACES_API_KEY}
                      onPlaceSelected={handlePlaceSelected}
                    />
                  </div>

                  <input
                    type="text"
                    // placeholder="Contact Person Name *"
                    className="input-text w-100 mt-2"
                    style={{ color: "black" }}
                    // onChange={(e) => {
                    //   let obj = { ...postVaccancy };
                    //   obj["contact_person_name"] = e.target.value;
                    //   setPostVaccancy(obj);
                    // }}
                    value={userData?.first_name + " " + userData?.last_name}
                    // disabled={disabled}
                    disabled="disabled"
                  // defaultValue={(prefilledData?.contact_person_name) ? (prefilledData?.contact_person_name) : (postVaccancy?.contact_person_name)}
                  />
                  <br />
                  <br />
                  <PhoneInput
                    inputStyle={{
                      width: "100%",
                      fontSize: "19px",
                      border: "0.5px solid gray",
                    }}
                    placeholder={t("Enter Mobile Number")}
                    type="text"
                    country={"IND"}
                    enableSearch={true}
                    // defaultValue='+91'
                    onChange={(phone, selectedCountry) => {
                      setPhone(phone);
                      setCountryCode(selectedCountry.dialCode);
                    }}
                    pattern="[0-9]{10}"
                    // value={postVaccancy?.contact_number}
                    value={
                      mobile_Number != undefined ? mobile_Number : phone == '' ? userData?.user?.phone : phone
                    }
                    name=""
                    id="phone"
                  />
                </div>

                <h5 className="my-3 form-heading">
                  {t("Qualification Required")}<span style={{ color: "red" }}>*</span>
                </h5>
                <div className="Qualification-Details mt-3">
                  <div className="mb-2 relative">
                    <select
                      id="degree"
                      className="input-text w-100 "
                      value={postVaccancy?.highest_degree}
                      onChange={(e) => {
                        let obj = { ...postVaccancy };
                        obj["highest_degree"] = e.target.value;
                        setPostVaccancy(obj);
                      }}
                      // value={postVaccancy.highest_degree}
                      // value={
                      //   prefilledData?.highest_degree
                      //     ? prefilledData?.highest_degree
                      //     : postVaccancy?.highest_degree
                      // }
                    >
                      <option value="select">
                        {t("Select Highest Degree")}
                      </option>
                      {degree?.map((item, index) => {
                        return (
                          <option value={item?.id} id={item?.id} key={index}>
                            {item?.degree}
                          </option>
                        );
                      })}
                    </select>

                    <button
                      className=" btn btn-primary addFields h-100"
                      onClick={(e) => {
                        setAddDegree(true);
                        e.preventDefault();
                      }}
                    >
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
                    </button>
                  </div>

                  <select
                    id="complete_degree_year"
                    className="input-text w-100 mb-2"
                    placeholder={t("Select Job Category")}
                    onChange={(e) => {
                      let obj = { ...postVaccancy };
                      obj["degree_completion_year"] = e.target.value;
                      setPostVaccancy(obj);
                    }}
                    // value={postVaccancy.degree_completion_year}
                    defaultValue={
                      prefilledData?.degree_completion_year
                        ? prefilledData?.degree_completion_year
                        : postVaccancy?.degree_completion_year
                    }
                  >
                    <option value="0">
                      {t("Highest Degree Completion Year")} *
                    </option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                    <option value="2011">2011</option>
                    <option value="2010">2010</option>
                    <option value="2009">2009</option>
                    <option value="2008">2008</option>
                    <option value="2007">2007</option>
                    <option value="2006">2006</option>
                    <option value="2005">2005</option>
                    <option value="2004">2004</option>
                    <option value="2003">2003</option>
                    <option value="2002">2002</option>
                    <option value="2001">2001</option>
                    <option value="2000">2000</option>
                    <option value="1999">1999</option>
                    <option value="1998">1998</option>
                    <option value="1997">1997</option>
                    <option value="1996">1996</option>
                    <option value="1995">1995</option>
                    <option value="1994">1994</option>
                    <option value="1993">1993</option>
                    <option value="1992">1992</option>
                    <option value="1991">1991</option>
                    <option value="1990">1990</option>
                    <option value="1989">1989</option>
                    <option value="1988">1988</option>
                    <option value="1987">1987</option>
                    <option value="1986">1986</option>
                    <option value="1985">1985</option>
                    <option value="1984">1984</option>
                    <option value="1983">1983</option>
                    <option value="1982">1982</option>
                    <option value="1981">1981</option>
                    <option value="1980">1980</option>
                    <option value="1979">1979</option>
                    <option value="1978">1978</option>
                    <option value="1977">1977</option>
                    <option value="1976">1976</option>
                    <option value="1975">1975</option>
                    <option value="1974">1974</option>
                    <option value="1973">1973</option>
                    <option value="1972">1972</option>
                    <option value="1971">1971</option>
                    <option value="1970">1970</option>
                    <option value="1969">1969</option>
                    <option value="1968">1968</option>
                    <option value="1967">1967</option>
                    <option value="1966">1966</option>
                    <option value="1965">1965</option>
                    <option value="1964">1964</option>
                    <option value="1963">1963</option>
                    <option value="1962">1962</option>
                    <option value="1961">1961</option>
                    <option value="1960">1960</option>
                  </select>

                  {/* <input
                    type="file"
                    // style="display: none;"
                    placeholder={t("Upload Your background image")}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      handleRecruiterImage(e);
                    }}
                    defalutValue={prefilledData?.imageURL}
                  /> */}
                </div>

                <h5 className=" form-heading mt-3">{lang && Object.keys(lang).length > 0 ? lang[ln]?.HireDetails["Post Settings"] : ""}<span style={{ color: "red" }}>*</span></h5>
                <div className="Qualification-Details mt-2">
                  <input
                    type="text"
                    placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Maximum Application Required"] : ""}
                    maxLength={5}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      var inputValue = e.target.value;
                      if (/^[0-9]*$/.test(e.target.value)) {
                        let obj = { ...postVaccancy };
                        obj["maximum_application_allowled"] = inputValue;
                        setPostVaccancy(obj);
                      }
                    }}
                    value={prefilledData?.maximum_application_allowled ? prefilledData?.maximum_application_allowled : postVaccancy.maximum_application_allowled}
                  // defaultValue={
                  //   prefilledData?.maximum_application_allowled
                  //     ? prefilledData?.maximum_application_allowled
                  //     : postVaccancy?.maximum_application_allowled
                  // }
                  />
                  <div className="date-column space-between d-flex">
                    <input
                      type="date"
                      // disabled
                      className={postVaccancy?.from_date == null || postVaccancy?.from_date == "" ? "input-date mt-2 mobile" : "input-date mt-2"}
                      name=""
                      id=""
                      min={minDate}
                      // value={selectedDate.toISOString().slice(0, 10)}
                      onChange={(e) => {
                        // handleDateChange()
                        if (e.target.value != "") {
                          let obj = { ...postVaccancy };
                          obj["from_date"] = e.target.value;
                          setPostVaccancy(obj);
                        } else {
                          let obj = { ...postVaccancy };
                          obj["from_date"] = "";
                          setPostVaccancy(obj);
                        }
                      }}
                      value={prefilledData?.from_date
                        ? prefilledData?.from_date
                        : postVaccancy?.from_date}
                    // defaultValue={
                    //   prefilledData?.from_date
                    //     ? prefilledData?.from_date
                    //     : postVaccancy?.from_date
                    // }
                    />
                    <input
                      type="date"
                      // disabled
                      className={postVaccancy?.to_date == null || postVaccancy?.to_date == "" ? "input-date mt-2 mobile" : "input-date mt-2"}
                      name=""
                      id=""
                      min={minDate}
                      onChange={(e) => {
                        console.log(e.target.value, "clear check")
                        if (e.target.value != "") {
                          let obj = { ...postVaccancy };
                          obj["to_date"] = e.target.value;
                          setPostVaccancy(obj);
                        } else {
                          let obj = { ...postVaccancy };
                          obj["to_date"] = "";
                          setPostVaccancy(obj);
                        }
                      }}
                      value={prefilledData?.to_date
                        ? prefilledData?.to_date
                        : postVaccancy?.to_date}
                    // defaultValue={
                    //   prefilledData?.to_date
                    //     ? prefilledData?.to_date
                    //     : postVaccancy?.to_date
                    // }
                    />
                  </div>
                  <input
                    type="text"
                    placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Enter Search Radius (In Meters)"] : ""}
                    maxLength={5}
                    className="input-text w-100 mt-2"
                    onChange={(e) => {
                      var inputValue = e.target.value;
                      if (/^[0-9]*$/.test(e.target.value)) {
                        let obj = { ...postVaccancy };
                        obj["search_radious"] = inputValue;
                        setPostVaccancy(obj);
                      }
                    }}
                    value={prefilledData?.search_radious ? prefilledData?.search_radious : postVaccancy.search_radious}
                  // defaultValue={
                  //   prefilledData?.search_radious
                  //     ? prefilledData?.search_radious
                  //     : postVaccancy?.search_radious
                  // }
                  />
                </div>
              </div>

              <div className="flex-center mt-3 w-100">
                {postVaccancy.id != undefined ? (
                  <button
                    type="submit"
                    onClick={handleUpdate}
                    className="theme-btn px-5 text-center"
                    style={{}}
                  >
                    {t("Update Vacancy")}
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={stopbtn}
                    onClick={(e) => handlePostVaccancy(e)}
                    className="theme-btn px-5 text-center"
                    style={{}}
                  >
                    {/* Review & */}
                    {/* Review & Post Vacancy */}
                    {stopbtn == false ? lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Post Vacancy"] : "" : t("Please wait")}
                  </button>
                )}
              </div>
            </div>
          </form>
          {addCat ? (
            // <AddDropdownPopup
            //   title={t("Add New Job Category")}
            //   placeholder={t("Job Category")}
            //   setPopupClose={setAddCat}
            //   handleChange={(e) => setCategory(e.target.value)}
            //   hanleClick={(e) => {
            //     postCategory();
            //   }}
            //   inputValue={category}
            // />
            <>
              <div className="blur-screen-full-area inner-modal flex-center">
                <div className="form-container company-form my-3">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h3 className=" skill-heading mb-3">{lang && Object.keys(lang).length > 0 ? lang[ln]?.Lastest["NewCategory"] : ""}</h3>
                    <p onClick={() => setAddCat(false)} style={{ cursor: 'pointer' }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Close"] : ""}</p>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    // style="display: none;"
                    placeholder={t("Upload Your background image")}
                    className=" custom-input border-2 w-100 mb-3 categ"
                    onChange={(e) => {
                      console.log(e.target.files[0].type,"check file type")
                      var inputFi = document.querySelector('.categ');
                      var filePath = e.target.value.toLowerCase();
                      var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                      if (!allowedExtensions.exec(filePath)) {
                          alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Please upload file having extensions .jpeg/.jpg/.png only.']:"");
                          setImagecatURL("")
                          inputFi.value = ""
                          return false
                      } else {
                          // File type is allowed, you can proceed with form submission or any further action
                          setIsdisable(true)
                          handleRecruiterImagescat(e);
                      }
                     
                    }}
                    defalutValue={imagecatURL}
                  />
                  <input
                    required=""
                    type="text"
                    placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.PostNewVacancy["Enter Job Title"] : ""}
                    class="input-text w-100 mb-2"
                    value={categoryname}
                    onChange={(e) => setCategoryname(e.target.value)}
                  />
                  <div className=" flex-center">
                    <button
                      disabled={isDisable}
                      type="submit"
                      onClick={() => postHandlecat()}
                      class="theme-btn px-5 text-center w-75"
                      style={{}}
                    >
                      { lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {addSkill ? (
            <AddDropdownPopup
            btns ={lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
              title={lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard["Skills"] : ""}
              placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard["Skills"] : ""}
              setPopupClose={setAddSkill}
              handleChange={(e) => setNewSkill(e.target.value)}
              hanleClick={(e) => {
                postSkill();
              }}
              inputValue={newSkill}
            />
          ) : null}
          {addDegree ? (
            <AddDropdownPopup
            btns ={lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
              title={lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Add New Degree"] : ""}
              placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Degree"] : ""}
              setPopupClose={setAddDegree}
              handleChange={(e) => setNewDegree(e.target.value)}
              hanleClick={(e) => {
                postDegree();
              }}
              inputValue={newDegree}
            />
          ) : null}
          {addCompany ? (
            <AddCompany
              // title="Add New Company"
              setPopupClose={setAddCompany}
              // setAddCompany={setAddCompany}
              setUpComp={setUpComp}
              upComp={upComp}
            // name={newCompany}
            // company_name={(e) => setNewCompany(e.target.value)}
            // location={companyLocation}
            // company_location={(e) => setCompanyLocation(e.target.value)}
            // about={aboutCompany}
            // about_company={(e) => setAboutCompany(e.target.value)}
            // image={companyImage}
            // company_image={(e) => setCompanyImage(e.target.value)}
            // website={companyWebsite}
            // company_website={(e) => setCompanyWebsite(e.target.value)}
            // hanleClick={() => {

            //   postCompany();
            // }}
            />
          ) : null}
          {addExperience ? (
            <AddDropdownPopup
              title={t("Add New Job Experience")}
              btns ={lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommBlackCard["Add"]:""}
              placeholder={t("Experience")}
              setPopupClose={setAddExperience}
              handleChange={(e) => setNewExperience(e.target.value)}
              hanleClick={(e) => {
                postExperience();
              }}
              inputValue={newExperience}
            />
          ) : null}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PostForm;
